import React from 'react';
import { useAuth } from '../context/AuthContext';

export enum PermMode {
  ANY,
  ALL
}
export interface WithOptionalPermissionProps {
  requiredPerms?: string[];
  mode?: PermMode;
  children: any;
}
export interface WithPermissionProps extends WithOptionalPermissionProps {
  requiredPerms: string[];
}

const WithPermission = ({ requiredPerms, children, mode = PermMode.ALL }: WithPermissionProps) => {
  const { checkPerm } = useAuth();
  return checkPerm(requiredPerms, mode) ? children : null;
};

export const WithOptionalPermission = ({
  requiredPerms,
  children,
  mode = PermMode.ALL
}: WithOptionalPermissionProps) => {
  if (Array.isArray(requiredPerms) && requiredPerms.length) {
    return (
      <WithPermission requiredPerms={requiredPerms} mode={mode}>
        {children}
      </WithPermission>
    );
  }

  return children;
};

export default WithPermission;
